import React from "react";
import { useUserId } from "../../../query/hooks/helpers";
import { useQueryPrimaryComplianceEntity } from "../../hooks/useQueryPrimaryComplianceEntity";
import { selectorComplianceEntityCountry } from "../../selectors/selectorComplianceEntityCountry";
import { useQueryMemberProfile } from "../../../query/users/queries";
import { Form } from "./Form";
import { useMutationSubmit } from "./useMutationSubmit";

type Props = {
  onSuccess?: () => void;
  onBack?: () => void;
  withPanel?: boolean;
  skipPayoutSettingsUpdate?: boolean;
  localCurrencyOnly?: boolean;
  fallbackCurrency?: string;
  lockCountry?: boolean;
};

export const FormManuallyAddInternationalAccount: React.FC<Props> = ({
  onSuccess,
  onBack,
  withPanel,
  skipPayoutSettingsUpdate,
  localCurrencyOnly,
  fallbackCurrency,
  lockCountry
}) => {
  const userId = useUserId();
  const queryCustomerEntity = useQueryPrimaryComplianceEntity();
  const queryMemberProfile = useQueryMemberProfile(userId);
  const [submit, submitMeta] = useMutationSubmit(
    { skipPayoutSettingsUpdate },
    {
      onSuccess
    }
  );

  if (!queryCustomerEntity.isFetched || !queryMemberProfile.isFetched) {
    return null;
  }

  const country =
    selectorComplianceEntityCountry(queryCustomerEntity.data) ||
    queryMemberProfile.data?.profile.address?.country;

  return (
    <Form
      onSubmit={data => {
        submit({ data });
      }}
      error={submitMeta.error}
      isLoading={submitMeta.isLoading}
      defaultValues={{
        country: country
      }}
      lockCountry={lockCountry}
      onBack={onBack}
      withPanel={withPanel}
      localCurrencyOnly={localCurrencyOnly}
      fallbackCurrency={fallbackCurrency}
    />
  );
};
